import { render, staticRenderFns } from "./RedeemDetailList.vue?vue&type=template&id=2e49b65e&scoped=true&"
import script from "./RedeemDetailList.vue?vue&type=script&lang=js&"
export * from "./RedeemDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49b65e",
  null
  
)

export default component.exports